module.exports = __webpack_public_path__ + "static/media/m1.e2d2c988.svg";